module.exports = __webpack_public_path__ + "img/table-graph.a9af7157.svg";